import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/banner_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Banner',
      options: ['web_link', 'image', 'mp_link', 'external_mp_link'],
    },
    model_name: 'Banner',
    column_name: 'kind',
  },
  page_position_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Banner',
      options: ['index_top'],
    },
    model_name: 'Banner',
    column_name: 'pagePosition',
  },
}
export const formColumnsConfig = {
  'self': {
    'page_position': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'image': { required: true, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
    'target': { required: false, disabledUpdate: false },
  },
  'target': {
    'url': { required: false, disabledUpdate: true },
    'appid': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Banner', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Banner', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
